export const INSTANCE = 'INSTANCE'
export default INSTANCE;